import { useTranslation } from "react-i18next";

import moment from "moment";

import { setStoredLanguage } from "../functions/functions";
import { Language, LANGUAGE_KEYS, LANGUAGES } from "../types";

const useLanguageConverter = () => {
  const { i18n } = useTranslation();

  const convertToLocale = (key: LANGUAGE_KEYS): LANGUAGES => {
    const map: Record<LANGUAGE_KEYS, LANGUAGES> = {
      [LANGUAGE_KEYS.En]: LANGUAGES.English,
      [LANGUAGE_KEYS.Lt]: LANGUAGES.Lithuanian,
      [LANGUAGE_KEYS.Es]: LANGUAGES.Spanish,
      [LANGUAGE_KEYS.De]: LANGUAGES.German,
      [LANGUAGE_KEYS.Fr]: LANGUAGES.French,
      [LANGUAGE_KEYS.It]: LANGUAGES.Italian,
      [LANGUAGE_KEYS.Pl]: LANGUAGES.Polish,
      [LANGUAGE_KEYS.Hu]: LANGUAGES.Hungarian
    };
    return map[key];
  };

  const convertFromLocale = (locale: LANGUAGES): LANGUAGE_KEYS => {
    const map: Record<LANGUAGES, LANGUAGE_KEYS> = {
      [LANGUAGES.English]: LANGUAGE_KEYS.En,
      [LANGUAGES.Lithuanian]: LANGUAGE_KEYS.Lt,
      [LANGUAGES.German]: LANGUAGE_KEYS.De,
      [LANGUAGES.Spanish]: LANGUAGE_KEYS.Es,
      [LANGUAGES.French]: LANGUAGE_KEYS.Fr,
      [LANGUAGES.Italian]: LANGUAGE_KEYS.It,
      [LANGUAGES.Polish]: LANGUAGE_KEYS.Pl,
      [LANGUAGES.Hungarian]: LANGUAGE_KEYS.Hu
    };
    return map[locale];
  };

  const setMomentLocale = (newLang: LANGUAGES, languages: Language[]) => {
    const currentLanguage = languages.find(lang => lang.id === newLang);

    const localeLanguage = currentLanguage
      ? currentLanguage.momentLocale
      : "en";

    moment.locale(localeLanguage);
  };

  const handleLanguageChange = (
    convertedLanguage: LANGUAGES,
    languages?: Language[]
  ) => {
    i18n.changeLanguage(convertedLanguage);
    setStoredLanguage(convertedLanguage || LANGUAGES.English);
    languages && setMomentLocale(convertedLanguage, languages);
  };

  return {
    convertToLocale,
    convertFromLocale,
    handleLanguageChange,
    setMomentLocale
  };
};

export default useLanguageConverter;
